module.exports = "<div class=\"leftsettingbox\">\r\n        <ul class=\"list-unstyled settinglist\">    \r\n        <li><a [routerLink]=\"['invoiceList']\"   routerLinkActive=\"active\"><strong> Invoice List</strong></a></li>\r\n        \r\n    </ul>     \r\n</div>  \r\n    <router-outlet style=\"visibility:hidden\"></router-outlet>\r\n\r\n\r\n\r\n      "


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/kcc/invoice/invoice.component.html
// module id = ./src/app/crm/kcc/invoice/invoice.component.html
// module chunks = main